import userClient from "../../services/httpClient/userClient";
import authClient from "../../services/httpClient/authClient";
import { rejectFailedStatus } from "services/httpClient/rejectFailedStatus";
import {
  BusinessDetailPayload,
  UpdateEmploymentDetailResponse,
  EmploymentDetailPayload,
  EmploymentDetailResponse,
  GetUserResponse,
  ReferralCodeResponse,
  UserUpdatePayload,
  UpdateUserResponse,
  BusinessDetailsResponse,
  ProfileImage,
  ProfileImageResponse,
  IdNumberConfirmationResponse,
  OtpValidatePayload,
  ValidateOtpResponse,
  // NewProfileImageResponse,
} from "./models";

export const getReferralCode = () =>
  userClient.get<ReferralCodeResponse>("/api/Customer/referral-code");

export const getEmploymentDetail = () =>
  userClient
    .get<EmploymentDetailResponse>("/api/Customer/employment-details")
    .then(rejectFailedStatus);

export const updateEmploymentDetail = (payload: EmploymentDetailPayload) =>
  userClient
    .put<UpdateEmploymentDetailResponse>(
      "/api/Customer/employment-details",
      payload
    )
    .then(rejectFailedStatus);

export const getUser = () =>
  userClient.get<GetUserResponse>("/api/Customer").then(rejectFailedStatus);

export const updateUser = (payload: UserUpdatePayload) =>
  userClient
    .put<UpdateUserResponse>("/api/Customer", payload)
    .then(rejectFailedStatus);

export const getBusinessDetails = () =>
  userClient
    .get<BusinessDetailsResponse>("/api/Customer/business-details")
    .then(rejectFailedStatus);

export const updateBusinessDetails = (payload: BusinessDetailPayload) =>
  userClient
    .put<BusinessDetailsResponse>("/api/Customer/business-details", payload)
    .then(rejectFailedStatus);

export const uploadProfileImage = (payload: ProfileImage) =>
  userClient.post<ProfileImageResponse>(
    "/api/Customer/upload-profile-image",
    payload
  );
export const getProfileImage = () =>
  userClient.get<ProfileImageResponse>("/api/Customer/get-profile-image");

export const confirmUserIdentity = (idNumber: string, idType: number) =>
  userClient.get<IdNumberConfirmationResponse>(
    `/api/Customer/identity-verification?idNumber=${idNumber}&idType=${idType}`
  );

// export const otpSend = () => userClient.post('/api/Otp/send')

export const otpValidate = async (payload: OtpValidatePayload) =>
  authClient.post("/api/Account/validate-otp", payload);



// export const setUpSecurityQuestion = async (body: any) => authClient.post(
//   '/api/Account/savesecurity-questions',
//   body
// )
